import './Theme.Application.1.scss';
export default 'ThemeApplication1';
